import moment from 'moment';

export const setNotification = (notificationId: string) => {
  localStorage.setItem(
    'notificationList',
    JSON.stringify({
      ...getNotificationList(),
      [notificationId]: new Date(),
    })
  );
};

export const getNotificationList = () => {
  const list = localStorage.getItem('notificationList');
  return JSON.parse(list || '{}');
};

export const isNotificationShowed = (notificationId: string): boolean => {
  const notificationsList = getNotificationList();
  const lastDate = notificationsList[notificationId];

  if (!lastDate) {
    return false;
  }
  const hoursDiff = moment().diff(lastDate, 'hours');

  return hoursDiff < 24;
};
